'use client';

import type { ClassValue } from 'clsx';

import {
  ProductComparisonNotice,
  ProductComparisonNoticeClose,
  ProductComparisonNoticeMark,
  ProductComparisonNoticeText,
} from '@vs-shop/commerce-ui/productComparisonNotice';
import { clsxm } from '@vs-shop/utils';
import { useIntl } from 'react-intl';

import { Url } from '../../../../../../route/router';

import Link from '@vs-shop/image-link/Link';

type Props = {
  onCloseAction: () => void;
  className?: ClassValue;
};

export default function ProductComparisonPopoverContent({ onCloseAction, className }: Props) {
  const intl = useIntl();

  return (
    <ProductComparisonNotice className={clsxm(className)}>
      <ProductComparisonNoticeMark />
      <ProductComparisonNoticeText>
        {intl.formatMessage(
          {
            id: 'productComparisonPopoverContent.addedToComparison.text',
            defaultMessage: 'Produkt přidán do porovnání. {link}',
          },
          {
            link: (
              <Link key="link" href={Url.productsComparison} className="text-destructive underline">
                {intl.formatMessage({
                  id: 'productComparisonPopoverContent.addedToComparison.link',
                  defaultMessage: 'Zobrazit porovnání',
                })}
              </Link>
            ),
          }
        )}
      </ProductComparisonNoticeText>

      <ProductComparisonNoticeClose
        onClick={onCloseAction}
        aria-label={intl.formatMessage({
          id: 'common.close',
          defaultMessage: 'Zavřít',
        })}
      />
    </ProductComparisonNotice>
  );
}
